import { MessageAttachment } from "@repo/ui/ai-elements/message";
import { Spinner } from "@repo/ui/spinner";

import type { PendingImage } from "./types";

/** Pending image thumbnail with loading state, wrapping {@link MessageAttachment}. */
export const ChatImagePreview = ({
  image,
  onRemove,
}: {
  image: PendingImage;
  onRemove: () => void;
}) => {
  if (!image.dataUrl) {
    return (
      <div className="flex size-8 shrink-0 items-center justify-center overflow-hidden rounded-md border bg-muted">
        <Spinner className="size-3" />
      </div>
    );
  }

  return (
    <MessageAttachment
      data={{
        type: "file",
        mediaType: image.mediaType,
        url: image.dataUrl,
      }}
      onRemove={onRemove}
    />
  );
};
